import { render, staticRenderFns } from "./GenericNotification.vue?vue&type=template&id=75a9283d&scoped=true"
import script from "./GenericNotification.vue?vue&type=script&lang=js"
export * from "./GenericNotification.vue?vue&type=script&lang=js"
import style0 from "./GenericNotification.vue?vue&type=style&index=0&id=75a9283d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a9283d",
  null
  
)

export default component.exports